import { memo } from 'react'

/** Figma "Triangle Warning" icon (warning variant of the bundle-authorization callout). */
export const TriangleWarningIcon = memo((props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M10 3C10.2827 3 10.5604 3.07264 10.8047 3.21094C11.049 3.34936 11.2512 3.54889 11.3906 3.78809L17.7861 14.668C17.9264 14.9041 17.9999 15.1726 18 15.4453C18 15.7179 17.9261 15.9855 17.7861 16.2217C17.6461 16.4578 17.4448 16.6545 17.2021 16.791C16.9595 16.9275 16.6837 16.9997 16.4033 17H3.61328C3.33143 17.0025 3.05364 16.9323 2.80859 16.7969C2.56361 16.6615 2.35977 16.4652 2.21777 16.2285C2.07587 15.9919 2.00065 15.7231 2 15.4492C1.99938 15.1752 2.07293 14.9053 2.21387 14.668L8.60938 3.78809C8.74881 3.54889 8.95097 3.34936 9.19531 3.21094C9.43958 3.07263 9.71733 3 10 3ZM10 13.5596C9.58593 13.5596 9.25023 13.8956 9.25 14.3096C9.25 14.7238 9.58579 15.0596 10 15.0596H10.0098C10.424 15.0596 10.7598 14.7238 10.7598 14.3096C10.7595 13.8956 10.4238 13.5596 10.0098 13.5596H10ZM10 6.53027C9.58579 6.53028 9.25 6.86606 9.25 7.28027V11.5605C9.25029 11.9745 9.58597 12.3105 10 12.3105C10.414 12.3105 10.7497 11.9745 10.75 11.5605V7.28027C10.75 6.86606 10.4142 6.53027Z"
      fill="currentColor"
    />
  </svg>
))
TriangleWarningIcon.displayName = 'TriangleWarningIcon'
